export const apiConfig = {
	baseURL: process.env.REACT_APP_SERVICE_URL,
	baseApiURL: `${process.env.REACT_APP_SERVICE_URL}/api`,
	apiUriVersion: process.env.REACT_APP_API_VERSION,
};
